import { DateTime } from 'luxon';
import * as Sentry from '@sentry/react';

export const toJSON = (raw: string) => {
  let response = null;
  try {
    response = JSON.parse(raw);
  } catch (err) {
    Sentry.captureException(err, { extra: { raw } });
  }
  return response;
};

export const getDateDifferenceInDays = (
  initialDate: DateTime,
  endDate: DateTime
): number => {
  const differeceInDays = Math.ceil(endDate.diff(initialDate, 'days').days);

  return differeceInDays;
};
